import * as yup from 'yup';

import { TRIPLE_TOGGLE_PRICING_TYPES } from '../components/ThreeToggleRates';
import { COMMERCIAL_CARDS, OTHER_CARDS, PERSONAL_CARDS } from '../sections/TransactionPricing';

const PER_ITEM_VALIDATION = yup
    .number()
    .when('type', (type, schema) =>
        ['BOTH', 'PER_ITEM'].includes(type) ? schema.required() : schema.notRequired()
    );

const PERCENTAGE_VALIDATION = yup
    .number()
    .when('type', (type, schema) =>
        ['BOTH', 'PERCENTAGE'].includes(type) ? schema.required() : schema.notRequired()
    );

export const TRIPLE_TOGGLE_VALIDATION = yup.object().shape({
    type: yup
        .string()
        .oneOf(TRIPLE_TOGGLE_PRICING_TYPES.map(({ value }) => value))
        .required(),
    baseRate: yup.number(),
    percentageBaseRate: yup
        .number()
        .when('type', (type, schema) => (type === 'PERCENTAGE' ? schema.required() : schema)),
    percentageLowestRate: PERCENTAGE_VALIDATION,
    percentageHighestRate: PERCENTAGE_VALIDATION,
    perItemBaseRate: PER_ITEM_VALIDATION,
    perItemLowestRate: PER_ITEM_VALIDATION,
    perItemHighestRate: PER_ITEM_VALIDATION,
    baseRatePercentage: yup.number().when('type', {
        is: 'BOTH',
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.notRequired(),
    }),
});

export const TRANSACTION_PRICING_VALIDATION = () => {
    let personalCards,
        commercialCards,
        otherCards = {};

    PERSONAL_CARDS.forEach(({ name }) => {
        personalCards = {
            ...personalCards,
            [name]: TRIPLE_TOGGLE_VALIDATION,
        };
    });
    COMMERCIAL_CARDS.forEach(({ name }) => {
        commercialCards = {
            ...commercialCards,
            [name]: TRIPLE_TOGGLE_VALIDATION,
        };
    });
    OTHER_CARDS.forEach(({ name }) => {
        otherCards = {
            ...otherCards,
            [name]: TRIPLE_TOGGLE_VALIDATION,
        };
    });
    return {
        personalCards: yup.object().shape(personalCards),
        commercialCards: yup.object().shape(commercialCards),
        otherCards: yup.object().shape(otherCards),
    };
};
